"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 0.1875rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: 'inherit';\n\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n\n  cursor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.StyledTextWrapperDiv = styled_components_1.default.div(_templateObject(), function (_ref) {
  var fontSize = _ref.theme.fontSize;
  return fontSize ? fontSize.default : "var(--font-size-default, 1.6rem)";
}, function (props) {
  return props.clickable ? 'pointer' : 'initial';
});
exports.StyledTextSpan = styled_components_1.default.span(_templateObject2());